import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import {
  MainNavbar,
  MainUserContent,
  MainIconContainer,
  MainDropdown,
  MainDropdownMenu,
  MainMenuItem,
  Logo,
  MainIcon,
  HeaderStyles,
} from "./HeaderStyles";
import CheckRender from "../Common/CheckRender";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import Colors from "../../themes/Colors";
import useEmpresa from "../../hooks/useEmpresa";
import { EMPRESA } from "../../utils/Constant";
import Text from "../Common/Text";

const CustomMainNavBar = (props) => {
  const { isLoginScreen } = props;

  const { prestador } = props?.authUserData;

  const empresa = useEmpresa();

  const [menuVisible, setMenuVisible] = useState(false);

  const menuRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuVisible(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const dimensionLogo =
    empresa?.CODIGO === EMPRESA.PRIMERA.CODIGO
      ? HeaderStyles.dimensionLogoPrimera
      : HeaderStyles.dimensionLogoHumano;

  return (
    <MainNavbar backGroundColor={empresa?.COLOR_PRINCIPAL}>
      <div>
        <a href={"/"}>
          <Logo
            src={empresa?.LOGO_BLANCO}
            width={dimensionLogo.width}
            height={dimensionLogo.height}
            alt="Logo"
          />
        </a>
      </div>

      <div>
        <MainIconContainer>
          <CheckRender allowed={!isLoginScreen}>
            <MainIcon>
              <MainDropdown ref={menuRef}>
                <UserOutlined style={{ color: Colors.white, fontSize: 25 }} />
                <MainUserContent font={empresa?.LETRA_PRINCIPAL}>
                  {prestador?.nombre}
                </MainUserContent>
                <LogoutOutlined
                  style={{ color: Colors.white, fontSize: 25 }}
                  onClick={() => setMenuVisible(!menuVisible)}
                />
                <CheckRender allowed={menuVisible}>
                  <MainDropdownMenu backGroundHover={empresa?.COLOR_PRINCIPAL}>
                    <MainMenuItem
                      href="/confirmacion"
                      font={empresa?.LETRA_PRINCIPAL}
                    >
                      <Text
                        size="15px"
                        color={Colors.primaryPrimera}
                        hoverColor={Colors.white}
                      >
                        Cerrar Sesión
                      </Text>
                    </MainMenuItem>
                  </MainDropdownMenu>
                </CheckRender>
              </MainDropdown>
            </MainIcon>
          </CheckRender>
        </MainIconContainer>
      </div>
    </MainNavbar>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(CustomMainNavBar);
